<template>

	<div class="backgroundClass">
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">积分商城>订单列表</div>
		<div>
			<el-row :gutter="10">
				<el-col :lg="16" class="grid-content">
					<div class="topTitle">
						<div class="green02"></div>
						<div class="topTitleSmall">数据概览</div>
					</div>
					<el-row class="main-content">
						<el-col :lg="6">
							<div class="main-title">
								销售额
							</div>
							<div class="main-number">
								￥123455
							</div>
						</el-col>
						<el-col :lg="6">
							<div class="main-title">
								订单数
							</div>
							<div class="main-number">
								338 单
							</div>
						</el-col>
						<el-col :lg="6">
							<div class="main-title">
								积分发行量
							</div>
							<div class="main-number">
								123455 积分
							</div>
						</el-col>
						<el-col :lg="6">
							<div class="main-title">
								积分使用量
							</div>
							<div class="main-number">
								36667 积分
							</div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>
		<div class="tableCol">
			<p>
				<el-select v-model="query.timeType" style="width: 150px; margin-right: 10px;" size="small">
					<el-option key="0" label="提交时间" value="0">提交时间</el-option>
					<el-option key="1" label="付款时间" value="1">付款时间</el-option>
				</el-select>
				<el-date-picker v-model="query.time" @change="filterOrder()" type="daterange" size="small"
					style="margin-left: 10px;margin-right: 25px; width: 250px;" value-format="yyyy-MM-dd"
					range-separator="至">
				</el-date-picker>
				<el-select v-model="query.type" style="width: 150px;margin-right: 20px;" size="small">
					<el-option v-for="item in keys" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" style="width: 250px;margin-right: 20px;" size="small" v-model="query.text"
					@keydown.enter.native="filterOrder()">
				</el-input>
				<span style="margin-left: 5px; margin-right: 10px;">使用券</span>
				<el-select v-model="query.payType" @change="filterOrder()"
					style="width: 150px;margin-left: 0px;margin-top: 1px;" size="small">
					<el-option v-for="item in orderStateList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				状态
				<el-select v-model="query.orderStatus" collapse-tags @change="filterOrder()"
					style="width: 150px;margin-left: 10px;margin-right: 20px;" size="small">
					<el-option v-for="item in orderStateList" :key="item.value" :label="item.label" :value="item.value"
						:disabled="query.orderStatus[0] == 100 && item.value != 100">
					</el-option>
				</el-select>
				<span style="float: right; ">
					<el-button size="small" class="buttonStyle01" @click="query.page = 1, filterOrder()">筛选 </el-button>
					<!-- <el-button size="small" class="buttonStyle" @click="reload()">重置</el-button>
					<el-button size="small" class="buttonStyle" @click="expor()" style="margin-left: 20px;">导出订单 </el-button> -->
				</span>
			</p>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-table :data="orders" v-loading="loading"
					:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
					style="width: 100%">
					<el-table-column prop="id" align="center" label="订单ID" width="70px"></el-table-column>
					<el-table-column prop="orderNo" align="center" label="订单编号" width="110px"></el-table-column>
					<el-table-column prop="orderType" align="center" label="订单类型" width="110">
						<template slot-scope="scope">
							{{ scope.row.orderType ==15?"积分商城订单":typeFormat }}
						</template>
					</el-table-column>
					<el-table-column label="商品服务" align="center" width="80">
						<template slot-scope="scope">
							{{ scope.row.type == null ? '/' : scope.row.type }}
						</template>
					</el-table-column>
					<el-table-column prop="nickName" align="center" label="用户昵称" width="100px"></el-table-column>
					<el-table-column align="center" label="用户属性" width="85px">
						<template slot-scope="scope">
							{{ scope.row.orderType == 11 ? (scope.row.customerType == 3 ? '首次会员' :
									customerType(scope.row.customerType)) : (scope.row.customerType
										== null ? '/' : customerType(scope.row.customerType))
							}}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="telphone" label="联系电话" width="115"></el-table-column>
					<el-table-column align="center" prop="total" label="服务价格" width="85">
						<template slot-scope="scope">
							{{ scope.row.total == null ? scope.row.payTotal == null ? '0' :
									scope.row.payTotal.toFixed(2)
									: scope.row.total.toFixed(2)
							}}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="couponTitle" label="使用优惠劵">
						<template slot-scope="scope">
							{{ scope.row.couponTitle ? scope.row.couponTitle : '/' }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="payTotal" label="支付总额" width="80">
						<template slot-scope="scope">
							{{ scope.row.payTotal == null ? '0' : scope.row.payTotal.toFixed(2) }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="addTime" label="订单创建时间" width="110"></el-table-column>
					<el-table-column align="center" prop="payTime" label="支付时间" width="100">
						<template slot-scope="scope">
							{{ scope.row.payTime ? scope.row.payTime : '/' }}
						</template>
					</el-table-column>
					<el-table-column align="center" label="订单状态" width="80px" fixed="right">
						<template slot-scope="scope">
							{{ statusRemark(scope.row.status) }}
						</template>
					</el-table-column>
					<el-table-column align="center" label="积分状态" width="80px" fixed="right">
						<template slot-scope="scope">
							/
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" width="85" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="show(scope.row.id)">详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: center;">
					<el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
						style="margin-top: 30px;" layout=" total, prev, pager, next, jumper" :current-page="query.page"
						:total="query.total">
					</el-pagination>
				</div>
			</div>
			<el-dialog title="订单详情" :visible.sync="detailSync" width="90%">
				<el-table :data="order"
					:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
					style="width: 100%">
					<el-table-column align="center" prop="id" label="订单ID" width="100px"></el-table-column>
					<el-table-column align="center" prop="orderNo" label="订单编号" width="120px"></el-table-column>
					<el-table-column align="center" prop="orderType" label="订单类型" width="100px"></el-table-column>
					<el-table-column align="center" prop="type" label="商品名称" width="100px"></el-table-column>
					<el-table-column align="center" prop="nickName" label="用户昵称" width="100px"></el-table-column>
					<el-table-column align="center" prop="userType" label="用户属性" width="100px"></el-table-column>
					<el-table-column align="center" prop="telphone" label="联系电话" width="110px"></el-table-column>
					<el-table-column align="center" prop="total" label="服务价格" width="100px"></el-table-column>
					<el-table-column align="center" label="使用优惠券" width="120px">
						<template slot-scope="scope">
							<div style="height:100px; text-overflow:ellipsis;">
								/
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="payTotal" label="实际支付" width="100px"></el-table-column>
					<el-table-column align="center" prop="addTime" label="订单创建时间" width="150px"></el-table-column>
					<el-table-column align="center" prop="payTime" label="支付时间" width="100px"></el-table-column>
					<el-table-column align="center" label="订单状态" width="120px" fixed="right">
						<el-select v-model="editData.status" placeholder="请选择" style="width: 100px;">
							<el-option v-for="item in orderStateList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-table-column>
					<el-table-column align="center" label="积分状态" width="80px" fixed="right">
						<template slot-scope="scope">
							/
						</template>
					</el-table-column>
					<!-- 输入框 获取积分数 -->
					<!-- <el-table-column label="获得积分数" width="100px"></el-table-column>
						<el-table-column label="使用积分数" width="100px"></el-table-column> -->
					<el-table-column align="center" prop="userId" label="获得积分数" width="150px">
						<template slot-scope="{row}">
							<el-input style="width: 120px;"></el-input>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="userId" label="使用积分数" width="150px">
						<template slot-scope="{row}">
							<el-input style="width: 120px;" placeholder="0"></el-input>
						</template>
					</el-table-column>
				</el-table>
				<div>
					<div class="add_botom_nei">
						<el-button size="small" @click="detailSync=false">取消</el-button>
						<el-button size="small" type="primary" @click="edit()">保存修改</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import Q from 'q';
	import {
		url,
		formatMoney
	} from '../../../utils/index.js'
	export default {
		data() {
			return {
				loading: false,
				url: url(),
				detailSync: false,
				query: {
					page: 1,
					size: 10,
					total: null,
					type: 0,
					text: "",
					addTime: null,
					orderStatus: [],
					orderType: [],
					channel: "",
					payType: "",
					timeType: '0',
					time: [],
					storeId: '',
				},
				keys: [{
					label: "订单号",
					value: 1,
				}, {
					label: "订单ID",
					value: 0,
				}, {
					label: "用户昵称/手机号",
					value: 3,
				}, {
					label: "商品名称",
					value: 2,
				}, ],
				orderStateList: [{
					label: "全部",
					value: 100,
				}, {
					label: "排队中",
					value: 0,
				}, {
					label: "服务中",
					value: 1,
				}, {
					label: "待付款",
					value: 2,
				}, {
					label: "已支付",
					value: 3,
				}, {
					label: "已完成",
					value: 5,
				}, {
					label: "已取消",
					value: -1,
				}, {
					label: "部分退款",
					value: -2,
				}, {
					label: "支付中",
					value: 21,
				}, ],
				// time: "",
				orders: [],
				order: [{
					id: 1
				}, {
					id: 2
				}],
				editData: {},
				stores: [], //营业门店
				storesEnd: [], //全部门店
				orderData: [{
					total: '',
					wechatTotal: '',
					meituanTotal: '',
					userCount: '',
					memberCount: '',
					memberTotal: '',
					enterprisePayTotal: '',
					haloTotal: ''
				}],
				customerTypeList: [{
					label: "生客",
					value: "0"
				}, {
					label: "熟客",
					value: "1"
				}, {
					label: "深度熟客",
					value: "2"
				}, {
					label: "首次消费",
					value: "3"
				}, ]
			};
		},
		computed: {
			statusRemark() {
				return (val) => {
					let result = '';
					this.orderStateList.forEach(ele => {
						if (ele.value == val) result = ele.label;
					});
					return result;
				}
			},
			customerType() {
				return (val) => {
					let result = '';
					this.customerTypeList.forEach(ele => {
						if (ele.value == val) result = ele.label;
					});
					return result;
				}
			},
		},
		mounted() {
			this.getOrders(1);
			this.getStores();
			this.getSummary(1);
		},
		methods: {
			show(id) {
				this.order = []
				this.$http.get("dOrder/details?id=" + id).then(res => {
					this.order.push(res.body.data);
					this.editData = this.order[0]
				});
				this.detailSync = true
			},
			edit() {
				if ((this.order.status != this.editData.status) || (this.order.remark != this.editData.remark)) {
					this.$http.post("dOrder/edit", {
						id: this.id,
						status: this.editData.status,
						remark: this.editData.remark
					}).then(res => {
						if (res.body.code) {
							this.$message.success('修改成功');
						}
					})
				}
				if (this.order.score != this.editData.score || this.order.proposal != this.editData.proposal) {
					let str = "?orderId=" + this.id + "&commentScore=" + this.order.score + "&proposal=" + this.order
						.proposal
					if (this.order.score && this.order.proposal) {
						this.$http.get("dOrder/commentEdit" + str).then(res => {
							if (res.body.code) {
								this.$message('修改评价成功');
							}
						})
					}
				}
				this.detailSync = false
			},
			reload() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					type: 0,
					text: "",
					addTime: null,
					orderStatus: [],
					orderType: "",
					channel: "",
					payType: "",
					timeType: '0',
					time: [],
				};
				this.filterOrder()
			},
			handleCurrentChange(val) {
				this.query.page = val;
				if (this.query.time[0] != undefined || this.query.time[0] != null) {
					this.getOrders()
				} else {
					this.getOrders(1)
				}
			},
			handleSizeChange(val) {
				this.query.size = val;
				if (this.query.time[0] != undefined || this.query.time[0] != null) {
					this.getOrders()
				} else {
					this.getOrders(1)
				}
			},
			expor() {
				if (this.query.time != null) {
					let a = this.requestData()
					var parm = this.toString(a)
					window.location.assign(this.url + "dOrder/exporDEvaluate" + parm)
				} else {
					this.$message.error("请设置时间范围再导出")
				}
			},
			toString(a) {
				var result = '?page=' + a.page + '&size=' + a.size +
					'&orderType=15'

				if (a.type != undefined) {
					result += '&type=' + a.type
				}
				if (a.text != undefined) {
					result += '&text=' + a.text
				}
				if (a.startTime != undefined) {
					result += '&startTime=' + a.startTime
				}
				if (a.endTime != undefined) {
					result += '&endTime=' + a.endTime
				}
				if (a.orderStatus != undefined && a.orderStatus != "") {
					result += '&orderStatus=' + a.orderStatus
				}
				if (a.payType != undefined) {
					result += '&payType=' + a.payType
				}
				if (a.storeId != undefined) {
					result += '&storeId=' + a.storeId
				}
				if (a.timeType != undefined) {
					result += '&timeType=' + a.timeType
				}
				return result
			},
			requestData(t) {
				var arr = {
					page: this.query.page,
					size: this.query.size,
					orderType: 15
				}
				if (t == 1) {
					arr.startTime = new Date().getFullYear() + '-01-01'
					arr.endTime = new Date().getFullYear() + '-12-31'
				} else {
					if (this.query.time.length > 0) {
						arr.timeType = this.query.timeType
						arr.startTime = this.query.time[0]
						arr.endTime = this.query.time[1]
					}
				}
				if (this.query.orderStatus != null && this.query.orderStatus != 100) {
					arr.orderStatus = this.query.orderStatus
				}
				if (this.query.payType != '') {
					arr.payType = this.query.payType
				}
				if (this.query.storeId != '') {
					arr.storeId = this.query.storeId
				}
				if (this.query.text != '') {
					arr.type = this.query.type
					arr.text = this.query.text
				}
				if (this.query.text != '' && this.query.time.length == 0 && this.query.time.length != null) {
					delete arr.timeType
					delete arr.startTime
					delete arr.endTime
				}
				return arr;
			},
			filterOrder() {
				if (this.query.time != null && (this.query.time[0] != undefined || this.query.time[0] != null)) {
					this.getOrders();
					this.getSummary();
				} else {
					this.getOrders(1);
					this.getSummary(1);
				}
			},
			getOrders(type) {
				this.loading = true;
				let t = setTimeout(() => { //15秒超时
					this.loading = false
					this.$message.error("请求失败")
				}, 15000)
				var a;
				if (type == 1) {
					a = this.requestData(1)
				} else {
					a = this.requestData()
				}
				this.$http.get("dOrder/list", {
					params: a
				}, {
					emulateJSON: true
				}).then(res => {
					if (res.data.code == 200) {
						this.orders = res.body.data.rows;
						this.query.total = res.body.data.total;
					} else {
						this.$message.error(res.data.msg);
					}
					this.loading = false
					clearTimeout(t)
				})
			},
			getSummary(type) {
				this.loading = true;
				let t = setTimeout(() => { //15秒超时
					this.loading = false
					this.$message.error("请求失败")
				}, 15000)
				var a;
				if (type == 1) {
					a = this.requestData(1)
				} else {
					a = this.requestData()
				}
				this.$http.get("dOrder/summary", {
					params: a
				}, {
					emulateJSON: true
				}).then(res => {
					if (res.data.code == 200) {
						const a = res.body.data;
						this.orderData[0].total = formatMoney(((a.orderTotal + a.memberTotal) / 100).toFixed(2))
						this.orderData[0].wechatTotal = formatMoney((a.wechatTotal / 100).toFixed(2))
						this.orderData[0].meituanTotal = formatMoney((a.meituanTotal / 100).toFixed(2))
						this.orderData[0].memberTotal = formatMoney((a.memberTotal / 100).toFixed(2))
						this.orderData[0].memberDetailTotal = formatMoney((a.memberDetailTotal / 100).toFixed(2))
						this.orderData[0].enterprisePayTotal = formatMoney((a.enterprisePayTotal / 100).toFixed(2))
						this.orderData[0].haloTotal = formatMoney((a.haloTotal / 100).toFixed(2))
						this.orderData[0].timeCardTotal = formatMoney((a.timeCardTotal / 100).toFixed(2))
						this.orderData[0].userCount = formatMoney(a.userCount, 0)
						this.orderData[0].memberCount = formatMoney(a.memberCount, 0)
						this.loading = false
						clearTimeout(t)
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType === 1) {
							this.storesEnd.push(ele) //结业门店
						} else {
							this.stores.push(ele) //营业门店
						}
					})
				})
			},
		},
	};
</script>


<style lang="less" scoped>
	.grid-content {
		border-radius: 4px;
		box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
	}

	.main-number {
		font-family: SourceHanSansCN-Bold;
		font-size: 22px;
	}

	.topRight {
		height: 100px;
	}

	.topRight>div {
		margin-top: 5px;
	}

	.tableCol {
		border-radius: 4px;
		box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
		margin: 30px -3px 0px -3px;
		padding: 5px 15px 30px 15px;
	}

	.bg-purple {
		background: #FFFFFF;
	}

	.main-content {
		padding: 30px 20px 20px 20px;
	}

	.waiTitel {
		display: flex;
		border-radius: 2px;
	}

	.green01 {
		height: 14px;
		width: 5px;
		background-color: #4AB52E;
		margin: 5px 0 0 0
	}

	.topTitle {
		display: flex;
	}

	.green02 {
		width: 5px;
		height: 5px;
		background: #4AB52E;
		margin: 15px 5px 0 5px
	}

	.topTitleSmall {
		margin: 5px 0 0 0;
		font-size: 16px;
		font-family: SourceHanSansCN-Bold;
	}

	.buttonStyle {
		// margin-right: 10px;
		font-family: SourceHanSansCN-Bold;
		background: #FFFFFF !important;
		border-radius: 5px;
		border: 1px solid #CBC9C9;
	}

	.buttonStyle01 {
		margin-right: 10px;
		font-family: SourceHanSansCN-Bold;
		color: #FFFFFF;
		background: #4AB52E !important;
		border-radius: 5px;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #4AB52E;
		border-radius: 5px;
		color: #FFF;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #4AB52E;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled) {
		border-radius: 5px;
	}

	/deep/.el-icon-arrow-down:before {
		content: "\e6d1";

	}
</style>